module.exports = __webpack_public_path__ + "static/media/O.0ebb158b.svg";